export default {
    es: {
        general: {
            title: '',
            submenu: {
                'asi-somos': 'Así somos',
                'que-ofrecemos': 'Qué ofrecemos',
                'tarifas': {
                    luz: {
                        hogar: "Luz Hogar",
                        empresas: "Luz Empresas",
                        /* "calcula-tu-ahorro": "Calcula tu ahorro" */
                    },
                    gas: {
                        hogar: "Gas Hogar",
                        empresas: "Gas Empresas",
                        /* "calcula-tu-ahorro": "Calcula tu ahorro" */
                    },
                    autoconsumo: {
                        particulares: "Particulares",
                        empresas: "Empresas",
                        agricultura:"Agricultura",
                        "calculadora": "Calcula tu ahorro"
                    },
                    aerotermia:"Aerotermia",
                    "coche-electrico":"Coche eléctrico"
                }
            },
            submenuResponsive: {
                'luz/hogar': 'Luz',
                'gas/hogar': 'Gas',
                'autoconsumo/particulares': 'Autoconsumo',
                'aerotermia': 'Aerotermia',
                'coche-electrico': 'Coche eléctrico',
            }
        },
        luz: {
            title: 'Luz',
            titleMobile: 'Luz',
            submenu: {
                'hogar': 'Hogar',
                'empresas': 'Empresas'
            },


        },
        gas: {
            title: 'Gas',
            titleMobile: 'Gas',
            submenu: {
                'hogar': 'Hogar',
                'empresa': 'Empresa'
            }
        },
        autoconsumo: {
            title: 'Autoconsumo',
            titleMobile: 'Solar',
            submenu: {
                'particulares': 'Particulares',
                'empresas': 'Empresas',
                'agricultura': 'Agricultura',
                'calculadora': 'Calcula tu ahorro',
            }
        },
        aerotermia: {
            title: 'Aerotermia',
            titleMobile: 'Clima',
        },
        'coche-electrico': {
            title: 'Coche eléctrico',
            titleMobile: 'Coche'
        },
    },
    en: {}
}


// WEBPACK FOOTER //
// ./src/translations/header.js